'use strict';

var React = require('react'),
    Button = require('../atoms/Button'),
    BtnGroup = require('../molecules/BtnGroup'),
    Icon = require('../atoms/Icon'),
    PageControls = require('../molecules/PageControls'),
    createStoreMixin = require('../mixins/createStoreMixin'),
    StampStore = require('../stores/StampStore'),
    ZineStore = require('../stores/ZineStore'),
    ZineLink = require('../atoms/ZineLink'),
    SidebarActionCreators = require('../actions/SidebarActionCreators'),
    SidebarTypes = require('../constants/SidebarTypes'),
    shallowEqual = require('react/lib/shallowEqual'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    { PropTypes } = React;

var StampReviewPageControls = React.createClass({
  mixins: [createStoreMixin(StampStore), PureRenderMixin],

  propTypes: {
    stampId: PropTypes.number.isRequired,
    zineSlug: PropTypes.string.isRequired
  },

  getStateFromStores(props) {
    return {
      stamp: StampStore.get(props.stampId),
      zine: ZineStore.get(props.zineSlug)
    };
  },

  componentWillReceiveProps(newProps) {
    if (!shallowEqual(newProps, this.props)) {
      this.setState(this.getStateFromStores(newProps));
    }
  },

  render() {
    var { zine } = this.state;

    return (
      <PageControls>
        <PageControls.Container>
          <PageControls.Message>
            <div>
              Submitted to <ZineLink bold zine={zine} />.
            </div>
            <div className='utils--hideOnMobile'>
              Accept or decline?
            </div>
          </PageControls.Message>
        </PageControls.Container>

        <PageControls.Separator />

        <PageControls.Container>
          <BtnGroup>
            <Button onClick={this.handleApproveClick}
                    context='PageControls'
                    round
                    fill
                    size='large'
                    color='green'>
              <Icon name='check'
                    mode='stroke' />
            </Button>

            <Button onClick={this.handleRejectClick}
                    context='PageControls'
                    round
                    fill
                    size='large'
                    color='red'>
              <Icon name='cross'
                    mode='stroke' />
            </Button>
          </BtnGroup>
        </PageControls.Container>
      </PageControls>
    );
  },

  handleApproveClick() {
    SidebarActionCreators.showSidebar(SidebarTypes.APPROVE_PENDING_STAMP, {
      stampId: this.props.stampId,
      zineSlug: this.props.zineSlug
    });
  },

  handleRejectClick() {
    SidebarActionCreators.showSidebar(SidebarTypes.REJECT_PENDING_STAMP, {
      stampId: this.props.stampId,
      zineSlug: this.props.zineSlug
    });
  }
});

module.exports = StampReviewPageControls;



/** WEBPACK FOOTER **
 ** ./pageControls/StampReviewPageControls.jsx
 **/